/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCaretDown = createReactComponent("caret-down", "IconCaretDown", [
  ["path", { d: "M6 10l6 6l6 -6h-12", key: "svg-0" }]
]);

export { IconCaretDown as default };
//# sourceMappingURL=IconCaretDown.js.map
